'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrivacyBand as SitePrivacyBand } from '@/components/site/privacy-band'

export function PrivacyBand() {
  const { t } = useTranslation(['web'])
  return (
    <SitePrivacyBand
      eyebrow={t('web:dictationPage.privacy.eyebrow')}
      titleKey="web:dictationPage.privacy.title"
      link={{ href: '/privacy', label: t('web:dictationPage.privacy.link') }}
      items={[
        { title: t('web:dictationPage.privacy.retentionTitle'), description: t('web:dictationPage.privacy.retentionDesc') },
        { title: t('web:dictationPage.privacy.trainingTitle'), description: t('web:dictationPage.privacy.trainingDesc') },
        { title: t('web:dictationPage.privacy.historyTitle'), description: t('web:dictationPage.privacy.historyDesc') },
      ]}
    />
  )
}
